import { logout } from '../../../utils/auth0'
import { Action, HandlerArgs } from '../../../types'

export default async function doSignOut(
  { dispatch }: HandlerArgs,
  { payload }: Action
) {
  logout()
}
